import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs'
import * as timezone from 'dayjs/plugin/timezone' 
import * as utc from 'dayjs/plugin/utc' 

dayjs.extend(utc)
dayjs.extend(timezone)
//import 'dayjs-timezone';

@Pipe({
  name: 'dateEventEnd' //this is used in html templates
})
export class DateEventEndPipe implements PipeTransform {

  transform(value: string): String {
            
    var thisDate = value;
    if (thisDate != null && thisDate.length != 0) {
    
        //var thisDateT = thisDate.substr(0, 10) + "T" + thisDate.substr(11, 8) + ".00Z"; // added time zone    
        return ' - ' + dayjs(thisDate).tz('Europe/Berlin').format('HH:mm'); //use dayjs.js 
        
        //incoming format 2017-04-06 08:45:00, no time zone
        //return ' - ' + dayjs(thisDate, "YYYY-MM-DD hh:mm:ss").format('MMMM DD, HH:mm');
    }
    return '';
  }

}
